/**
 *
 * @param key - 关键字
 * @param value - 值
 * @param {storage=} localStorage
 */
import { ENTRYQUERYINFOKEY } from '@/config/constant'

export function setStorage(
  key: string,
  value: string | Record<string, unknown>,
  storage = window.localStorage
): void {
  try {
    storage.setItem(key, typeof value === 'object' ? JSON.stringify(value) : value)
  } catch (e) {
    console.log(e)
  }
}

/**
 *
 * @param key - 关键字
 * @param {storage=} localStorage
 * @returns
 */
export function getStorage<T>(
  key: string,
  storage = window.localStorage
): string | Record<string, unknown> | T | null {
  const value = storage.getItem(key)
  try {
    if (value) return JSON.parse(value)
    return value
  } catch (err) {
    return value
  }
}
export function removeStorage(key: string, storage = window.localStorage): void {
  storage.removeItem(key)
}

export function copy<T>(obj: T): T {
  return typeof obj === 'object' ? JSON.parse(JSON.stringify(obj)) : obj
}

export function parseNumber(n: number | string | unknown, m = 0): number {
  return parseFloat(parseFloat(n as string).toFixed(m))
}

export function formatRequestByParantheses(urlStr: string, data: Record<string, string>): string {
  const keyArr = []
  const formateUrl = urlStr.replace(/\{(\w+)\}/g, (match, key) => {
    keyArr.push(key)
    return typeof data[key] === 'undefined' ? '' : data[key]
  })
  return formateUrl
}

export function getValueBySearch(url: string, target: string): string | undefined {
  const matchReg = new RegExp(`[?|&]${target}=(\\w+)`)
  const targetStr = url.match(matchReg)
  if (targetStr && targetStr.length === 2) {
    return targetStr[1]
  }
}

export const getThousandMoney = (num: number | string): string => {
  // 先提取整数部分
  return num.toString().replace(/\d+/, function (n) {
    // 对整数部分添加分隔符
    return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
      return $1 + ','
    })
  })
}

export const getQueryStringArgs = (url: string): Record<string, string> => {
  const arr = url.split('?')
  const qs = arr.length === 2 ? arr[1] : ''
  const args: Record<string, string> = {}
  const items = qs.length ? qs.split('&') : []
  for (let i = 0; i < items.length; i++) {
    const item = items[i].split('=')
    const name = decodeURIComponent(item[0])
    const value = decodeURIComponent(item[1])
    if (name.length) {
      args[name] = value
    }
  }
  return args
}

export function getEntryInfo(): Record<string, string> {
  let EntryData = getStorage<Record<string, string>>(ENTRYQUERYINFOKEY, sessionStorage) as Record<
    string,
    string
  >
  EntryData = EntryData || {}
  const isFromMemberUnToken = EntryData?.mini === 'member' && !EntryData?.token ? '1' : ''
  return { ...EntryData, isFromMemberUnToken }
}
export function getCurrentDayRelativeMilliSeconds(timeStamp: number): number {
  // 获取相对当天0点的秒数
  const time = new Date(timeStamp)
  time.setHours(0, 0, 0, 0)
  const startTime = time.getTime()
  return timeStamp - startTime
}
// 校验中国身份证号码
// 一代身份证号是15位的数字，二代身份证都是18位的
// 最后一位校验位除了可能是数字还可能是'X'或'x'，所以有四种可能性：
// a.15位数字
// b.18位数字
// c.17位数字，第十八位是'X'
// d.17位数字，第十八位是'x'
export function validateIDCard(str: string): boolean {
  return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(str)
}

export function getMapOptions<T = string>(
  MapValue: Map<T, string>,
  all = false
): Array<{
  label: string
  value: T | string
}> {
  const arr: Array<{
    label: string
    value: T | string
  }> = all ? [{ label: '全部', value: '' }] : []
  MapValue.forEach((label, value) => {
    arr.push({ label, value })
  })
  return arr
}

// 睡眠函数
export function sleep(time = 100): Promise<null> {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(null)
    }, time)
  })
}

// 判断是否为本地环境
export function judgeIsLocalDevEnv() {
  const isLocalDev =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '0.0.0.0' ||
    window.location.hostname.includes('local') ||
    window.location.port === '3000' ||
    window.location.port === '8080' ||
    window.location.port === '5173'
  return isLocalDev
}
